"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseModel = void 0;
const typescript_json_serializer_1 = require("typescript-json-serializer");
/**
 * Base model for all domain entities.
 *
 * ⚠️ Guideline:
 * - Use model instances for all internal work.
 * - Use `toString()` when you need a wire-format (JSON string) payload.
 * - Use `fromString()` / `fromJson()` to convert wire-format payloads back into models.
 *
 * We intentionally do not expose a public `toJson` API on models to discourage
 * working with loose JSON objects throughout the codebase.
 */
class BaseModel {
    /**
     * Serializes the model into a JSON string suitable for sending over the wire.
     */
    toString() {
        const payload = new typescript_json_serializer_1.JsonSerializer().serialize(this);
        return JSON.stringify(payload);
    }
    /**
     * Deserializes a model instance from a JSON string (wire format).
     */
    static fromString(jsonString) {
        return new typescript_json_serializer_1.JsonSerializer().deserialize(jsonString, this);
    }
    /**
     * Deserializes a model instance from a JSON object (e.g. parsed wire payload).
     */
    static fromJson(jsonObject) {
        return new typescript_json_serializer_1.JsonSerializer().deserialize(jsonObject, this);
    }
}
exports.BaseModel = BaseModel;
